import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import SmoothScroll from "smooth-scroll";

import AuthContext from './Context/authContext';
import { getFromStore } from './Utils/storage-helpers';
import NavBar from './Layouts/NavBar';
import Pages from './Pages';

import logo from './Assets/Images/logo/whiteLogo.png';
import "./App.css";

// [TODO:Gbolly] Still need to work on this for the home page
export const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 1000,
    speedAsDuration: true,
});

const navStyle = { backgroundColor: "#41889A" };

const textStyle = {
    color: '#FFF'
};

const App = () => {
    const [user, setUser] = useState({});
    const [isAuthenticated, setAuth] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showSpotNavBar, setShowSpotNavBar] = useState(false);
    const [ownersSpots, setOwnersSpots] = useState([]);
    const userObj = useMemo(() => (
        { user, setUser }),
        [user]
    );
    const authObj = useMemo(() => (
        { isAuthenticated, setAuth }),
        [isAuthenticated]
    );
    const admin = useMemo(() => (
        { isAdmin, setIsAdmin }),
        [isAdmin]
    );
    const spots = useMemo(() => (
        { ownersSpots, setOwnersSpots }),
        [ownersSpots]
    );
    const location = useLocation();

    useEffect(() => {
        getToken();
    })

    useEffect(() => {
        getUser();
    }, [isAuthenticated]);

    useEffect(() => {
        const regexBusinessSpotPages = /\/(business|dashboard|spot\/[\w\d]+)/;
        setIsAdmin(regexBusinessSpotPages.test(location.pathname));
        setShowSpotNavBar(/\/spot\/\d+/.test(location.pathname));
    }, [location.pathname]);

    useEffect(() => {
        const isRaverRoute = location.pathname.includes('/raver');
        if (isRaverRoute) {
            document.body.classList.add('no-padding');
        } else {
            document.body.classList.remove('no-padding');
        }
        return () => {
            document.body.classList.remove('no-padding');
        };
    }, [location.pathname]);

    const getToken = async () => {
      const token = await getFromStore('accessToken');

      if (token) {
        setAuth(true);
      } else {
        setAuth(false);
      }
    };

    const getUser = async () => {
        const currentUser = await getFromStore("user");
        setUser(currentUser);
    };

    return (
        <AuthContext.Provider value={{
            ...authObj,
            ...userObj,
            ...admin,
            ...spots
        }}>
            {((!isAdmin && !location.pathname.startsWith('/raver')) || (isAdmin && ["/dashboard", "/business"].includes(location.pathname))) && (
                <NavBar
                    navLogo={logo}
                    navStyle={navStyle}
                    navLinkTextStyle={textStyle}
                />
            )}
            <Pages />
        </AuthContext.Provider>
    );
}

export default App;
